import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import InputRadio from '../Symbols/InputRadio';
import InputCurrency from '../Symbols/InputCurrency';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import { baseTypeOptions } from './Options';
import InputSelect from '../Symbols/InputSelect';
import { YEARS } from '../LegalParameters/Constants';

const years = YEARS.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { monthlyIncome = '', baseType = 'month', year },
		ppm = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka otcovské dovolené">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputRadio
					label="Vyměřovací základ:"
					name="baseType"
					radio={baseTypeOptions}
					onChange={changeHandler('baseType')}
					onBlur={validateHandler('baseType')}
					value={baseType}
					passedProps={{ 'data-cy': 'baseType' }}
				/>
				<InputCurrency
					label="Zadejte vyměřovací základ:"
					onChange={changeHandler('monthlyIncome')}
					onBlur={validateHandler('monthlyIncome')}
					value={monthlyIncome}
					error={errors.monthlyIncome}
				/>
				<Info css={Row}>
					Vyměřovací základ je průměr hrubých příjmů v rozhodném období (zpravidla za posledních 12
					měsíců), zadávejte buď měsíční průměr nebo denní průměr.
				</Info>
				<div css={Row}>
					<Button>Výpočet</Button>
				</div>
				{ppm && <Result ppm={ppm} year={year} />}
				{ppm && (
					<div css={Row}>
						<Button onClick={reset}>Nový výpočet</Button>
					</div>
				)}
				<Info css={Row}>
					<p>DVZ je Denní Vyměřovací Základ</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
